export default "__VITE_ASSET__3ad482e9__"